(() => {
  if (window.headerWishlistInitialized) return;
  window.headerWishlistInitialized = true;

  const ADDED_EVENT = 'sw:addedtowishlist';
  const REMOVED_EVENT = 'sw:removedfromwishlist';

  const setHasItems = hasItems => {
    document.querySelectorAll('.trigger-wishlist').forEach(link => {
      link.classList.toggle('has-items', hasItems);
    });
  };

  const syncWishlistIcon = () => {
    if (typeof _swat === 'undefined' || typeof _swat.fetchWrtEventTypeET !== 'function') return;
    try {
      _swat.fetchWrtEventTypeET(products => {
        setHasItems(Array.isArray(products) && products.length > 0);
      }, 4);
    } catch (error) {
      console.error('Header wishlist: could not fetch wishlist', error);
    }
  };

  const listenToWishlistChanges = swat => {
    const events = window.SwymTracker?.JSEvents || {};
    const added = events.addedToWishlist || ADDED_EVENT;
    const removed = events.removedFromWishlist || REMOVED_EVENT;
    if (!swat?.evtLayer) return;
    swat.evtLayer.addEventListener(added, () => setHasItems(true));
    swat.evtLayer.addEventListener(removed, () => setTimeout(syncWishlistIcon, 300));
  };

  const onSwymReady = swat => {
    syncWishlistIcon();
    listenToWishlistChanges(swat || window._swat);
  };

  window.HeaderWishlist = { sync: syncWishlistIcon };

  if (!window.SwymCallbacks) window.SwymCallbacks = [];
  window.SwymCallbacks.push(onSwymReady);
  if (typeof _swat !== 'undefined') onSwymReady(window._swat);
})();
